import { useContext, useMemo } from 'react';
import { FeaturedFlagsContext, FeaturedFlagsUnion } from './FeaturedFlagsContext';

export const useFeaturedFlags = (featuredFlags: FeaturedFlagsUnion[]): boolean[] => {
  const { enabledFeatures } = useContext(FeaturedFlagsContext);

  return useMemo(() => featuredFlags.map((f) => enabledFeatures.includes(f)), [enabledFeatures]);
};
